import gql from "graphql-tag";

export const SIGN_DOCUMENT = gql`
  mutation SignDocuments($data: SubscriptionDataInput) {
    signDocuments(data: $data) {
      response
    }
  }
`;
const esigns = {
  SIGN_DOCUMENT,
};

export default esigns;
